import { render } from "./DataToPayAlert.vue?vue&type=template&id=53ecc5c2"
import script from "./DataToPayAlert.vue?vue&type=script&lang=js"
export * from "./DataToPayAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__